/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 11/06/2019
 *
 * The app-properties details to generate tables
 * @tableId - unique table id
 * @rowClickUrl - this pat is used to navigate when clicks a table row
 * @tableBaseUrl - base url
 * @defaultId - this attribute is used to send the object id in url when click a table raw
 * @tableHeaders - Headers of the table
 * @tableAttributes - the attribute name relavant ot the table header
 * @headerVisibility - the default visibility of the header
 * @isSortable - enable or disable the sorting
 * @isFilterable - enable or disable the filtering
 * @columnFilters - wheather need to have a filter or not
 * @columnWidths - column width
 * @columnDataAlignment - column data alignment
 */

const tableConfigs = {
    partner: {
        tableId: 1,
        rowClickUrl: "/home/partners/",
        tableBaseUrl: "/partners?page-no=",
        defaultId: "partnerId",
        tableHeaders: ["Name","SSO Site ID","Disabled URL","Enabled","MAC Key","Created Date","Modified Date"],
        tableAttributes: ["partnerName","ssoSiteId","disabledUrl","enabled","macKey","createdDate","modifiedDate"],
        headerVisibility: [true,true,true,true,true,true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true,true,false,false,false,false,false],
        columnWidths: ['auto',140,'auto',90,175,240,240],
        columnDataAlignment: ['left','right','left','center','center','center','center']
    },
    partnerRole: {
        tableId: 2,
        rowClickUrl: "/home/partnerRoles/",
        tableBaseUrl: "/partner-roles?page-no=",
        defaultId: "partnerRoleId",
        tableHeaders: ["Partner", "Partner Role Name"],
        tableAttributes: ["partnerName", "partnerRoleName"],
        headerVisibility: [true, true],
        columnFilters: [true, true],
        columnWidths: ['auto', 'auto'],
        columnDataAlignment: ['left', 'left']
    },
    partnerUrls: {
        tableId: 3,
        rowClickUrl: "/home/partnerUrls/",
        tableBaseUrl: "/partner-urls?page-no=",
        defaultId: "partnerUrlId",
        tableHeaders: ["Partner", "Partner Url Type", "URL", "Created Date", "Modified Date"],
        tableAttributes: ["partnerName", "partnerUrlTypeName", "url", "createdDate", "modifiedDate"],
        headerVisibility: [true, true, true, true, true],
        isSortable: true,
        isFilterable: false,
        columnFilters: [false, false, false, false, false],
        columnWidths: ['auto', 140, 'auto', 240, 240],
        columnDataAlignment: ['left', 'left', 'left', 'center', 'center']
    },
    partnerUrlTypes: {
        tableId: 4,
        rowClickUrl: "/home/partnerUrlTypes/",
        tableBaseUrl: "/partner-url-types?page-no=",
        defaultId: "partnerUrlTypeId",
        tableHeaders: ["Name","Description","Created Date","Modified Date"],
        tableAttributes: ["partnerUrlTypeName","description","createdDate","modifiedDate"],
        headerVisibility: [true,true,true,true],
        isSortable: true,
        isFilterable: false,
        columnFilters: [false,false,false,false],
        columnWidths: ['auto','auto',240,240],
        columnDataAlignment: ['left','left','center','center']
    },
    institutions: {
        tableId: 5,
        rowClickUrl: "/home/institutions/",
        tableBaseUrl: "/institutions?page-no=",
        defaultId: "institutionId",
        tableHeaders: ["Name","Partner","Enabled","Disabled Url","Master User Consent","School Aware","Created Date","Modified Date"],
        tableAttributes: ["institutionName","partnerName","enabled","disabledUrl","masterConsent","schoolAware","createdDate","modifiedDate"],
        headerVisibility: [true,true,true,true,false,false,true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true,true,false,false,false,false,false,false],
        columnWidths: ['auto','auto','auto','auto','auto','auto',240,240],
        columnDataAlignment: ['left','left','center','left','center','center','center','center']
    },
    institutionUrl: {
        tableId: 6,
        rowClickUrl: "/home/institutionUrls/",
        tableBaseUrl: "/institution-urls?page-no=",
        defaultId: "institutionUrlId",
        tableHeaders: ["Institution","Partner","Partner Url Type","Url","Created Date","Modified Date"],
        tableAttributes: ["institutionName","partnerName","partnerUrlTypeName","institutionUrl","createdDate","modifiedDate"],
        headerVisibility: [true,true,true,true,true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true,true,true,false,false,false],
        columnWidths: ['auto','auto','auto','auto',240,240],
        columnDataAlignment: ['left','left','left','left','center','center']
    },
    institutionUnblock: {
        tableId: 25,
        rowClickUrl: "/home/institutionUnblock/",
        tableBaseUrl: "/unblock-institutions?page-no=",
        defaultId: "institutionId",
        tableHeaders: ["Institution Name","Partner","Organization Id","Course Blocked","Blocked Start Date"],
        tableAttributes: ["name","partnerName","organizationId","courseCreationBlocked","courseCreationBlockedStartDate"],
        headerVisibility: [true,true,true,true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true,true,true,false,false],
        columnWidths: ['auto','auto','auto','auto',240],
        columnDataAlignment: ['left','left','left','center','center'],

    },
    lms: {
        tableId: 7,
        rowClickUrl: "/home/lms/",
        tableBaseUrl: "/lms?page-no=",
        defaultId: "lmsId",
        tableHeaders: ["Name","Base URL","Disabled URL","Enabled","MAC Key","Created Date","Modified Date"],
        tableAttributes: ["lmsName","lmsBaseUrl","disabledUrl","enabled","macKey","createdDate","modifiedDate"],
        headerVisibility: [true,true,true,true,false,true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true,false,false,false,false,false,false],
        columnWidths: ['auto','auto','auto',90,175,240,240],
        columnDataAlignment: ['left','left','left','center','center','center','center']
    },
    lmsUrlTypes: {
        tableId: 7,
        rowClickUrl: "/home/lmsUrlTypes/",
        tableBaseUrl: "/lms-url-types?page-no=",
        defaultId: "lmsUrlTypeId",
        tableHeaders: ["Name","Description","Created Date","Modified Date"],
        tableAttributes: ["lmsUrlTypeName","description","createdDate","modifiedDate"],
        headerVisibility: [true,true,true,true],
        isSortable: true,
        isFilterable: false,
        columnFilters: [false,false,false,false],
        columnWidths: ['auto','auto',240,240],
        columnDataAlignment: ['left','left','left','left']
    },
    lmsProperties: {
        tableId: 8,
        rowClickUrl: "/home/lms-properties/",
        tableBaseUrl: "/lms-properties?page-no=",
        defaultId: "lmsPropertyId",
        tableHeaders: ["LMS","Name","Value","Created Date","Modified Date"],
        tableAttributes: ["lmsName","lmsPropertyName","lmsPropertyValue","createdDate","modifiedDate"],
        headerVisibility: [true,true,true,true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true,true,true,false,false],
        columnWidths: ['auto','auto','auto',240,240],
        columnDataAlignment: ['left','left','left','center','center']
    },
    applicationProperties: {
        tableId: 9,
        rowClickUrl: "/home/application-properties/",
        tableBaseUrl: "/application-properties?page-no=",
        defaultId: "propertyId",
        tableHeaders: ["Name","Value","Created Date","Modified Date"],
        tableAttributes: ["name","value","createdDate","modifiedDate"],
        headerVisibility: [true,true,true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true,true,false,false],
        columnWidths: ['auto','auto',90,90],
        columnDataAlignment: ['left','left','center','center']
    },
    pearsonRoles: {
        tableId: 10,
        rowClickUrl: "/home/pearson-roles/",
        tableBaseUrl: "/pearson-roles?page-no=",
        defaultId: "pearsonRoleId",
        tableHeaders: ["Name"],
        tableAttributes: ["pearsonRoleName"],
        headerVisibility: [true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true],
        columnWidths: ['auto'],
        columnDataAlignment: ['left']
    },
    courseRoles: {
        tableId: 11,
        rowClickUrl: "/home/course-roles/",
        tableBaseUrl: "/course-roles?page-no=",
        defaultId: "courseRoleId",
        tableHeaders: ["Partner Role","Pearson Role"],
        tableAttributes: ["partnerNameWithPartnerRole","pearsonRoleName"],
        headerVisibility: [true,true],
        isSortable: false,
        isFilterable: false,
        columnFilters: [false,false],
        columnWidths: [90,90],
        columnDataAlignment: ['left','left']
    },
    adminRoles: {
        tableId: 12,
        rowClickUrl: "/home/admin-roles/",
        tableBaseUrl: "/admin-roles?page-no=",
        defaultId: "adminRoleId",
        tableHeaders: ["Authority","Description"],
        tableAttributes: ["adminRoleAuthority","adminRoleDescription"],
        headerVisibility: [true,true],
        isSortable: true,
        isFilterable: false,
        columnFilters: [false,false],
        columnWidths: [90,90],
        columnDataAlignment: ['left','left']
    },
    viewAudit: {
        tableId: 13,
        rowClickUrl: "/home/view-audit/",
        tableBaseUrl: "/view-audit?per-page=10&page-no=",
        defaultId: "outcomesAuditId",
        tableHeaders: ["ID","Partner","Institution","Course","Type","Status","Error","Transaction Id","Datasource","Created Date"],
        tableAttributes: ["outcomesAuditId","outComesAuditPartnerName","outComesAuditInstitutionName","outComesAuditCourseId","outComesAuditMessageType","outComesAuditStatus","outComesAuditError","outComesAuditTransactionId","outComesAuditDataSource","outComesAuditCreatedDate"],
        headerVisibility: [true,true,true,true,true,true,true,true,true,true],
        isSortable: true,
        isFilterable: false,
        columnFilters: [false,false,false,false,false,false,false,false,false,false],
        columnWidths: ['auto','auto','auto','auto','auto','auto','auto','auto','auto','auto'],
        columnDataAlignment: ['center','center','center','left','center','center','left','center','center','center']
    },
    viewError: {
        tableId: 14,
        rowClickUrl: "/home/view-error/",
        tableBaseUrl: "/view-error?per-page=10&page-no=",
        defaultId: "outcomesErrorId",
        tableHeaders: ["ID","Partner","Institution","Course","Type","Status","Error","Transaction Id","Datasource","Created Date"],
        tableAttributes: ["outcomesErrorId","outComesErrorPartnerName","outComesErrorInstitutionName","outComesErrorCourseId","outComesErrorMessageType","outComesErrorStatus","outComesErrorError","outComesErrorTransactionId","outComesErrorDataSource","outComesErrorCreatedDate"],
        headerVisibility: [true,true,true,true,true,true,true,true,true,true],
        isSortable: true,
        isFilterable: false,
        columnFilters: [false,false,false,false,false,false,false,false,false,false],
        columnWidths: ['auto','auto','auto','auto','auto','auto','auto','auto','auto','auto'],
        columnDataAlignment: ['center','center','center','left','center','center','left','center','center','center']
    },
    audit: {
        tableId: 15,
        rowClickUrl: "/home/audit/",
        tableBaseUrl: "/audit?per-page=10&page-no=",
        defaultId: "tpiAuditId",
        tableHeaders: ["ID", "Action", "Controller", "Email", "Param", "Date Created"],
        tableAttributes: ["tpiAuditId", "tpiAuditAction", "tpiAuditController", "tpiAuditEmail", "tpiAuditParam", "tpiAuditCreatedDate"],
        headerVisibility: [true, true, true, true, true, true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [false, false, false, true, false, false],
        columnWidths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
        columnDataAlignment: ['center', 'center', 'center', 'left', 'left', 'left']
    },
    lmsUrls: {
        tableId: 16,
        rowClickUrl: "/home/lmsUrls/",
        tableBaseUrl: "/lms-urls?page-no=",
        defaultId: "lmsUrlId",
        tableHeaders: ["Url", "Lms", "Lms Url Type", "Created Date", "Modified Date"],
        tableAttributes: ["lmsUrlLink", "lmsName", "lmsUrlTypeName", "lmsUrlCreatedDate", "lmsUrlModifiedDate"],
        headerVisibility: [true, true, true, true, true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true, true, false, false, false],
        columnWidths: ['auto', 140, 'auto', 240, 240],
        columnDataAlignment: ['left', 'left', 'left', 'center', 'center']
    },
    accounts: {
        tableId: 17,
        rowClickUrl: "/home/accounts/",
        tableBaseUrl: "/account?page-no=",
        defaultId: "accountId",
        tableHeaders: ["First Name","Last Name","Email","Roles"],
        tableAttributes: ["accountFirstName","accountLastName","accountEmail","accountAdminRoles"],
        headerVisibility: [true,true,true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [false,false,true,false],
        columnWidths: ['auto','auto','auto','auto'],
        columnDataAlignment: ['left','left','left','left']
    },
    coreLogs: {
        tableId: 18,
        rowClickUrl: "/home/coreLogs/",
        pageSize: 10,
        tableBaseUrl: "/logs?per-page=10&page-no=",
        defaultId: "logTraceId",
        tableHeaders: ["Course Id","Partner","Institution","User Id","Level","Created Date", "Message"],
        tableAttributes: ["logCourseName","logPartner","logInstitution","logUserName","logLogLevel","logCreatedDate","logMsg"],
        headerVisibility: [true,true,true,true,true,true,true],
        isSortable: true,
        isFilterable: false,
        defaultSorted: [{ id: 'logCreatedDate', desc: true }],
        columnFilters: [false,false,false,false],
        columnWidths: ['auto', 150, 150,'auto', 140, 240, 'auto'],
        columnDataAlignment: ['left','left','left','left','center','left','left']
    },
    toolProviders: {
        tableId: 19,
        rowClickUrl: "/home/toolProviders/",
        tableBaseUrl: "/tool_provider?page-no=",
        defaultId: "toolStatusId",
        tableHeaders: ["LMS", "Status", "Modified Date", "Modified By", "Last Down"],
        tableAttributes: ["lmsName", "toolStatusUp", "toolStatusModifiedDate", "toolStatusModifiedBy", "toolStatusLastDown"],
        headerVisibility: [true, true, true, true, true],
        isSortable: false,
        isFilterable: true,
        columnFilters: [true, false, false, false, false],
        columnWidths: ['auto', 'auto', 'auto', 'auto', 'auto'],
        columnDataAlignment: ['left', 'center', 'center', 'center', 'center']
    },
    urlGroups: {
        tableId: 20,
        rowClickUrl: "/home/url-groups/",
        tableBaseUrl: "/url-group?page-no=",
        defaultId: "urlGroupId",
        tableHeaders: ["Name","Course URL","Enroll URL","Course Role URL","User URL","Outcomes URL"],
        tableAttributes: ["urlGroupName","courseURL","enrollURL","ssoURL","userURL","outcomesURL"],
        headerVisibility: [true,true,true,true,true,true],
        isSortable: true,
        isFilterable: false,
        columnFilters: [false,false,false,false,false,false],
        columnWidths: ['auto','auto','auto','auto','auto','auto'],
        columnDataAlignment: ['left','left','left','left','left','left']
    },
    federations: {
        tableId: 21,
        rowClickUrl: "/home/federations/",
        tableBaseUrl: "/federation-record?page-no=",
        defaultId: "fedUserMappingId",
        tableHeaders: ["External User ID", "IES User ID", "IDP User ID", "SMS ID", "Partner ID", "Institution ID", "Tool Proxy GUID", "Created Date"],
        tableAttributes: ["fedExternalUserId","fedIesUserId","fedIdpUserId","fedSmsId","fedPartnerId","fedInstitutionId", "fedToolProxyGuid","fedCreatedDate"],
        headerVisibility: [true, true, true,true, true, true, true, true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [false, false, false, false, false, false,false, false],
        columnWidths: ['auto','auto','auto','auto'],
        columnDataAlignment: ['left','left','left','left']
    },
    cacheSetup: {
        tableId: 22,
        rowClickUrl: "/home/cache-setup/",
        tableBaseUrl: "/cache-setup?page-no=",
        defaultId: "id",
        tableHeaders: ["Host", "URL", "Created Date", "Modified Date"],
        tableAttributes: ["host","url","createdDate","modifiedDate"],
        headerVisibility: [true, true, true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true, true, false, false],
        columnWidths: ['auto','auto','auto','auto'],
        columnDataAlignment: ['left','left','left','left']
    },
    cacheReset: {
        tableId: 24,
        rowClickUrl: "/home/cache-reset/",
        tableBaseUrl: "cache-setup/getCacheClearAudits?per-page=10&page-no=",
        defaultId: "id",
        tableHeaders: ["User Name","Reset Date", "Message"],
        tableAttributes: ["userName","clearedTime","failedHost"],
        headerVisibility: [true, true, true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [false, false, false, false],
        columnWidths: ['auto','auto','auto'],
        columnDataAlignment: ['left','left','left']
    },
    utf8EnabledToolProfile: {
        tableId: 22,
        rowClickUrl: "/home/utf8EnabledToolProfile/",
        tableBaseUrl: "/utf8EnabledToolProfile?page-no=",
        defaultId: "utf8EnabledToolProfileId",
        tableHeaders: ["Tool Profile Code","Tool Profile Description","Enabled Date"],
        tableAttributes: ["ltiToolProfile.code","ltiToolProfile.description","createdDate"],
        headerVisibility: [true,true,true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [true,false,false],
        columnWidths: ['auto','auto',240],
        columnDataAlignment: ['left','left','center']
    },
    consumerKey: {
        tableId: 23,
        rowClickUrl: "/home/utf-enabled-consumer-key/",
        tableBaseUrl: "/utf-enabled-consumer-key?per-page=10&page-no=",
        defaultId: "id",
        tableHeaders: ["Consumer Key", "Partner", "Institute"],
        tableAttributes: ["name","partnerName","instituteName"],
        headerVisibility: [true, true, true],
        isSortable: true,
        isFilterable: true,
        columnFilters: [false, true, true],
        columnWidths: ['auto','auto','auto'],
        columnDataAlignment: ['left','left','left']
    }

};

export default tableConfigs;
